import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';
import { DatatableComponent } from './../../shared/components/data-table/datatable.component';
import { ConsultaPagosService } from '../../services/http/consultaPagos.service';
import { ModalService } from '../../shared/services/modal.service';

declare let gtag: Function;

@Component({
  selector: 'app-declaraciones-presentadas-reteica',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './declaraciones_presentadas_reteica.component.html',
  styleUrl: './declaraciones_presentadas_reteica.component.scss'
})

export class DeclaracionesPresentadasReteICAComponent extends DatatableComponent implements OnInit {

  showViewHTMLComponent = false;
  listActividades = [];

  override originalData: any[] = [];

  constructor(private router: Router,
    private consultaPagosService: ConsultaPagosService,
    private modalService:ModalService,
    private authService: AuthService) {
    super()
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    } else {

    }
    const config = this.authService.getValueConfig();

  }

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }
    this.obtenerRelacion();
    this.applyFilter();

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/retencion_ica/declaraciones_presentadas' });
      } catch (err) {}
    }

  }

  obtenerRelacion() {
    this.consultaPagosService.getRelacionReteICA().subscribe({
      next: (response) => {
        if (!(response === undefined)) {
          let aInfo = this.verificaArray(response.detalles);
          if (!((response.detalles == null) || (aInfo.length < 1))) {
            this.originalData = this.verificaArray(response.detalles);
            this.applyFilter()
            this.showViewHTMLComponent = true;
          }
        } else {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando información");
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  }

  override applyFilter(): void {
    const searchTerm = this.filterTerm.toLowerCase();
    this.currentData = this.originalData.filter(item =>
      String(item.vigencia).toLowerCase().includes(searchTerm) ||
      String(item.nombrePeriodo).toLowerCase().includes(searchTerm) ||
      String(item.nroReferencia).toLowerCase().includes(searchTerm) ||
      String(item.nroTransaccion).toLowerCase().includes(searchTerm) ||
      String(item.nomBanco).toLowerCase().includes(searchTerm) ||
      String(item.fechaPresentacion).toLowerCase().includes(searchTerm) ||
      String(item.indPago).toLowerCase().includes(searchTerm)
    );

    this.currentPage = 1;
  }

  printCertification(idSoporte: any) {
    if (typeof gtag === 'function') {
      try {
        gtag('event', 'print_tax_certification', {
          'event_category': 'Reports',
          'event_label': 'ReteICA'
        });
      } catch (err) { }
    }
    const config = this.authService.getValueConfig();
    window.open(config.urlCertPagos + idSoporte);
  }
}
